// Conversation id encoding for ephemeral subscribe frames (base64url, no padding).

export function conversationIdToBase64Url(convId: Uint8Array): string {
  if (convId.length !== 16) {
    throw new Error('conversation id must be 16 bytes');
  }
  return base64UrlEncode(convId);
}

export function base64UrlToConversationId(encoded: string): Uint8Array {
  const bytes = base64UrlDecode(encoded.trim());
  if (bytes.length !== 16) {
    throw new Error('conversation id must decode to 16 bytes');
  }
  return bytes;
}

export function hexToConversationId(hex: string): Uint8Array {
  const normalized = hex.trim().toLowerCase();
  if (normalized.length !== 32) {
    throw new Error('conversation id hex must be 32 characters');
  }
  const out = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    out[i] = Number.parseInt(normalized.slice(i * 2, i * 2 + 2), 16);
  }
  return out;
}

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  const b64 = btoa(binary);
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlDecode(s: string): Uint8Array {
  const padded = s.replace(/-/g, '+').replace(/_/g, '/');
  const padLen = (4 - (padded.length % 4)) % 4;
  const withPad = padded + '='.repeat(padLen);
  const binary = atob(withPad);
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    out[i] = binary.charCodeAt(i);
  }
  return out;
}
